<template slot-scope="props">
  <div class="animated fadeIn">
    <form @submit.stop.prevent="post()">
      <b-row>
        <b-col sm="12">
          <b-card id="card-relatorio" 
            :bg-variant="isDark ? 'dark' : 'white'" 
            :text-variant="isDark ? 'light' : 'dark'"
            :footer-bg-variant="isDark ? 'dark' : 'light'">
            
            <div slot="header" class="d-flex align-items-center justify-content-between" :class="isDark ? 'bg-dark border-secondary' : ''">
                <div>
                  <i class='fa fa-file-text-o mr-2'></i><strong>Relatório de Abate</strong>
                </div>
            </div>

            <!-- Seção 1: Configuração do Relatório -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-cog mr-2"></i>Tipo de Relatório</h6>
              <b-row>
                <b-col md="12" sm="12">
                  <b-form-group label="Selecione o Tipo de Relatório">
                    <b-form-select :plain="true" v-model="tipoRelatorio" :options="opcoesRelatorio" :class="isDark ? 'bg-secondary text-white border-info' : ''" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="habilitaTipoProcesso">
                <b-col sm="12">
                   <b-form-group label="Status do Lote">
                    <b-form-checkbox-group
                      id="edTipoStatus"
                      v-model="tipoStatus"
                      :options="statusOptions"
                      name="edTipoStatus"
                      :class="isDark ? 'text-light' : ''"
                    ></b-form-checkbox-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 2: Filtros Principais -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-filter mr-2"></i>Filtros Principais</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Fornecedor">
                    <cliente-pesquisa 
                      @retornaId="CLIENTE_ID = $event"
                      :idInicial="CLIENTE_ID"
                      :desabilitarInput="!habilitaCLIENTE_ID"
                      place="Todos os Fornecedores"
                      ref="clientepesquisa"
                      idModal="modalFornecedor"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Marchant">
                    <cliente-pesquisa 
                      @retornaId="MARCHANT_ID = $event"
                      :idInicial="MARCHANT_ID"
                      :desabilitarInput="!habilitaMARCHANT_ID"
                      place="Todos os Marchants"
                      ref="marchantpesquisa"
                      idModal="modalMarchant"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Fazenda">
                    <cliente-pesquisa 
                      @retornaId="FAZENDA_ID = $event"
                      :idInicial="FAZENDA_ID"
                      :desabilitarInput="!habilitaFAZENDA_ID"
                      place="Todas as Fazendas"
                      ref="fazendapesquisa"
                      idModal="modalFazenda"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Custo Operacional">
                    <custo-operacional-drop-down 
                      v-model="CUSTOOPERACIONAL_ID"
                      :disabled="!habilitaCUSTOOPERACIONAL_ID"
                      ref="custooperacionaldropDown"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Conferente">
                    <vendedor-dropdown
                      v-model="FUNCIONARIO_ID"
                      v-if="habilitaFUNCIONARIO_ID"
                      ref="funcionariopesquisa"
                      placeholder="Todos os Conferentes"
                    />
                    <b-form-select v-else disabled :plain="true" :class="isDark ? 'bg-secondary text-white border-info' : ''" value="N/A" :options="[{text: 'Não aplicável para este tipo de relatório', value: 'N/A'}]" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 3: Período -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-calendar mr-2"></i>Período</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Data Início">
                    <cec-input-data id="dt1" v-model="DT1" :state="DT1 ? null : false" />
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Data Fim">
                    <cec-input-data id="dt2" v-model="DT2" :state="DT2 ? null : false" />
                  </b-form-group>
                </b-col>
                
              </b-row>
              <b-row>
                <b-col md="6" sm="12" v-if="habilitaTipoProcesso">
                  <b-form-group label="Processo">
                    <b-form-select :plain="true" v-model="tipoProcesso.valor" :options="tipoProcesso.opcoes" :class="isDark ? 'bg-secondary text-white border-info' : ''" />
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Agrupar por:">
                    <b-form-select :plain="true" v-model="agrupamento.valor" :options="agrupamento.opcoes" :class="isDark ? 'bg-secondary text-white border-info' : ''" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div slot="footer" class="p-3" :class="isDark ? 'bg-dark border-top border-secondary' : 'bg-light'">
              <b-row class="justify-content-center">
                <b-col md="6" sm="12">
                  <vue-button-spinner block size="lg" type="submit" variant="primary" :isLoading="isLoading" :disabled="isLoading" :status="status" class="btn-generate shadow-sm">
                    <i class="fa fa-file-pdf-o mr-2"></i> GERAR RELATÓRIO
                  </vue-button-spinner>              
                </b-col>
                
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'
import CustoOperacionalPesquisa from '../pesquisa/CustoOperacionalPesquisa.vue'
import ClientePesquisa from '../pesquisa/ClientePesquisa.vue'
import VendedorDropdown from '../componentes/dropdown/VendedorDropdown.vue' // Using VendedorDropdown as general Funcionario dropdown if specific one not suitable
import CustoOperacionalDropDown from '../componentes/dropdown/CustoOperacionalDropDown.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import moment from 'moment'

export default {
  components: {
    VueButtonSpinner,
    CustoOperacionalPesquisa,
    ClientePesquisa,
    VendedorDropdown,
    CustoOperacionalDropDown,
    CecInputData
  },
  data () {
    return {
      CLIENTE_ID: null,
      CUSTOOPERACIONAL_ID: null,
      FUNCIONARIO_ID: null,
      MARCHANT_ID: null,
      FAZENDA_ID: null,
      DT1: moment().format('YYYY-MM-DD'),
      DT2: moment().format('YYYY-MM-DD'),
      tipoRelatorio: '1',
      opcoesRelatorio: [
        { text: 'Analítico por Lote', value: '1' },
        { text: 'Sintético - dia a dia', value: '2' },
        { text: 'Rendimento das Carcaças e Miúdos', value: '3' }
      ],
      tipoProcesso: {
        opcoes: [
          { value: '0', text: 'Ambos' },
          { value: '1', text: 'Próprio' },
          { value: '2', text: 'Serviço' }
        ],
        valor: '0'
      },
      agrupamento: {
        valor : '',
        opcoes: [],
        analiticoOpcoes: [
          { value:  '', text: 'Não Agrupar' },
          { value: 'D', text: 'Data' },
          { value: 'C', text: 'Fornecedor' },
          { value: 'F', text: 'Fazenda' },
          { value: 'M', text: 'Marchante' }
        ],
        fechamentoOpcoes: [
          { value:  '', text: 'Todos' },
          { value: 'D', text: 'Data' }
        ]
      },
      isLoading: false,
      status: '',
      submmited: false,
      tipoStatus: ['5','6'],
      statusOptions: [
        {text: 'CANCELADA', value: '0'},
        {text: 'LANCAMENTOS PRINCIPAIS', value: '1'},
        {text: 'PLANEJAMENTO CONCLUIDO', value: '2'},
        {text: 'PRONTO PARA COLETA', value: '3'},
        {text: 'COLETA INICIADA', value: '4'},
        {text: 'COLETA ENCERRADA', value: '5'},
        {text: 'FECHADO', value: '6'},
        {text: 'PAUSA', value: '7'}
      ]
    }
  },
  
  computed: {
    isValid () {
      return !!this.DT1 && !!this.DT2
    },
    isDark () {
      return this.$store.getters['tema/IS_DARK']
    },
    habilitaCLIENTE_ID () {
        return ['1','2'].includes(this.tipoRelatorio)
    },
    habilitaMARCHANT_ID () {
        return ['1','2'].includes(this.tipoRelatorio)
    },
    habilitaFAZENDA_ID () {
        return ['1','2'].includes(this.tipoRelatorio)
    },
    habilitaCUSTOOPERACIONAL_ID () {
        return ['1','2'].includes(this.tipoRelatorio)
    },
    habilitaFUNCIONARIO_ID () {
        return ['1','2'].includes(this.tipoRelatorio)
    },
    habilitaTipoProcesso () {
        return ['1','2'].includes(this.tipoRelatorio)
    }
  },
  methods: {
    post () {
      if (!this.isValid) {
        this.$toast.warn({
          title: 'Aviso',
          message: 'Por favor, informe o período desejado',
          progressBar: false,
          showMethod: 'shake',
          position: 'top full width'
        })
        return
      }

      this.$store.commit('controle/setAguardando', true)
      this.isLoading = true

      const params = {
        fornecedorid: this.CLIENTE_ID,
        marchantid: this.MARCHANT_ID,
        fazendaid: this.FAZENDA_ID,
        custoid: this.CUSTOOPERACIONAL_ID,
        funcionarioid: this.FUNCIONARIO_ID,
        dt1: this.DT1,
        dt2: this.DT2,
        lbfornecedor: this.$refs.clientepesquisa?.$refs?.auto?.display || '',
        lbmarchant: this.$refs.marchantpesquisa?.$refs?.auto?.display || '',
        lbfazenda: this.$refs.fazendapesquisa?.$refs?.auto?.display || '',
        lbcusto: this.getLabelFromDropDown('custooperacionaldropDown', this.CUSTOOPERACIONAL_ID),
        lbfuncionario: this.getLabelFromDropDown('funcionariopesquisa', this.FUNCIONARIO_ID),
        tipoProcesso: this.tipoProcesso.valor,
        agrupamento: this.agrupamento.valor,
        lbusuario: window.localStorage.getItem('nomeusuario'),
        lbempresa: window.localStorage.getItem('nomeempresa'),
        tiporel: this.tipoRelatorio
      }

      if (this.tipoStatus && this.tipoStatus.length > 0) {
        params.status = this.tipoStatus.join('-')
      }

      // Remove undefined/null params to keep URI clean
      Object.keys(params).forEach(key => (params[key] === undefined || params[key] === null) && delete params[key])

      const uri = '/api/protected/relatorios/abate/analitico?' + new URLSearchParams(params).toString()

      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.$store.commit('controle/setAguardando', false)
          this.isLoading = false
          this.$toast.success({
            title: 'Sucesso',
            message: 'Relatório Gerado com Sucesso',
            progressBar: false,
            timeOut: 3000,
            showMethod: 'shake',
            position: 'top full width'
          })
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          window.open(url)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          this.isLoading = false
          this.$toast.error({
            title: 'Erro',
            message: 'Ocorreram erros ao gerar o Relatório',
            progressBar: false,
            showMethod: 'shake',
            position: 'top full width'
          })
        })
    },
    getLabelFromDropDown (refName, value) {
      if (!value) return ''
      const component = this.$refs[refName]
      if (component && component.options) {
        const option = component.options.find(o => o.value === value)
        return option ? option.text : ''
      }
      return ''
    },
    trocarValorAgrupamento () {
      return !this.agrupamento.opcoes.some(e => e.value === this.agrupamento.valor)
    }
  },
  created () {
    this.tipoRelatorio = '1'
    this.agrupamento.opcoes = this.agrupamento.analiticoOpcoes
  },
  watch: {
    'tipoRelatorio': function () {
      if (['1','2'].includes(this.tipoRelatorio)) {
        this.agrupamento.opcoes = this.agrupamento.analiticoOpcoes
        if (this.trocarValorAgrupamento()) {
          this.agrupamento.valor = ''
        }
      } else if (['3','4'].includes(this.tipoRelatorio)) {
        this.agrupamento.opcoes = this.agrupamento.fechamentoOpcoes
        if (this.trocarValorAgrupamento()) {
          this.agrupamento.valor = ''
        }
      } else {
        this.agrupamento.opcoes = []
        this.agrupamento.valor = ''
      }
    }
  }
}
</script>

<style scoped>
.section-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e4e7ea;
  transition: all 0.3s ease;
}

.section-container:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.section-container.dark-mode {
  background: #2f353a;
  border-color: #434a50;
}

.section-title {
  color: #20a8d8;
  border-bottom: 1px solid #c2cfd6;
  padding-bottom: 8px;
  margin-bottom: 20px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 1px;
}

.section-title.dark-mode {
  color: #63c2de;
  border-color: #434a50;
}

.btn-generate {
  font-weight: 700;
  letter-spacing: 1px;
  padding: 12px;
  transition: all 0.3s;
}

.btn-generate:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(32, 168, 216, 0.4);
}

.dark-mode .form-group label {
  color: #a4b7c1;
}

#card-relatorio {
  border-radius: 12px;
  overflow: hidden;
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/views/relatorios/RelAbate.vue